// extracted by mini-css-extract-plugin
module.exports = {"bgImage":"bg-image_bgImage__N32wY","bgOverlay":"bg-image_bgOverlay__WJ3_G"};